import { styles } from "@routes/InvestmentPriorityRoute/styles";

const STROKE = "#FFAC7D";
const FILL = "#FFAC7D";

export const MinimumChart = () => {
  return (
    <svg
      width="157"
      height="44"
      viewBox="0 0 157 44"
      fill="none"
      aria-hidden="true"
      style={styles.chart}
    >
      <defs>
        <linearGradient
          id="min-mask-grad"
          x1="78.5"
          y1="31.5"
          x2="0"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={FILL} />
          <stop stopColor={FILL} offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="min-fill-grad"
          x1="79"
          y1="7"
          x2="79"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={STROKE} />
          <stop offset="1" stopColor={STROKE} stopOpacity="0" />
        </linearGradient>
        <mask id="min-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="157" height="44">
          <path d="M0 0H157V34C157 39.5228 152.523 44 147 44H0V0Z" fill="url(#min-mask-grad)" />
        </mask>
      </defs>
      <g mask="url(#min-mask)">
        <path
          d="M0 30.7671C2.79422 30.7671 3.70444 28.9455 5.06977 28.9455C6.4351 28.9455 9.40531 31.0393 11.9024 31.0393C13.1626 31.0393 14.6271 29.2481 17.8129 29.2481C20.5435 29.2481 22.1231 30.1594 23.8048 30.1594C25.4865 30.1594 27.4539 28.107 29.9151 28.107C32.3764 28.107 34.0728 30.5032 35.7073 30.5032C37.3417 30.5032 38.7479 28.8826 41.5188 28.8826C44.2897 28.8826 47.3692 26.5782 48.5199 26.5782C49.6706 26.5782 51.491 28.5714 53.7666 28.5714C55.587 28.5714 58.7716 26.3041 60.5121 26.3041C64.4372 26.3041 65.2771 27.7604 70.5511 27.7604C73.0338 27.7604 75.6118 25.7919 77.8874 25.7919C80.1629 25.7919 81 26.5782 83.3169 26.5983C85.6339 26.6184 86.2054 23.5911 88.6455 23.5911C91.0856 23.5911 92.4155 27.2943 95.2194 27.2943C97.9614 27.2943 97.9591 22.5581 100.677 22.5581C102.965 22.5581 102.918 27.5408 105.301 27.5408C107.684 27.5408 107.971 23.1821 112.192 23.1821C114.798 23.1821 116.368 23.8633 118.161 23.8633C119.973 23.8633 121.625 20.0976 123.9 20.0976C126.176 20.0976 127.662 22.0393 129.153 22.0393C129.963 22.0393 134.257 21.2887 136.415 23.2464C138.574 25.2042 140.515 22.2752 141.919 22.2752C143.322 22.2752 144.186 22.1218 145.913 22.1218C147.639 22.1218 148.071 18.5634 149.551 18.5634C151.031 18.5634 152.667 23.1519 153.807 20.8577C154.946 18.5636 158 18 158 18"
          stroke={STROKE}
          strokeWidth="2"
        />
        <path
          d="M70.5511 27.7604C65.2771 27.7604 64.4372 26.3041 60.5121 26.3041C58.7716 26.3041 55.587 28.5714 53.7666 28.5714C51.491 28.5714 49.6706 26.5782 48.5199 26.5782C47.3692 26.5782 44.2897 28.8826 41.5188 28.8826C38.7479 28.8826 37.3417 30.5032 35.7073 30.5032C34.0728 30.5032 32.3764 28.107 29.9151 28.107C27.4539 28.107 25.4865 30.1594 23.8048 30.1594C22.1231 30.1594 20.5435 29.2481 17.8129 29.2481C14.6271 29.2481 13.1626 31.0393 11.9024 31.0393C9.40531 31.0393 6.4351 28.9455 5.06977 28.9455C3.70444 28.9455 2.79422 30.7671 0 30.7671V44H158V18C158 18 154.946 18.5636 153.807 20.8577C152.667 23.1519 151.031 18.5634 149.551 18.5634C148.071 18.5634 147.639 22.1218 145.913 22.1218C144.186 22.1218 143.322 22.2752 141.919 22.2752C140.515 22.2752 138.574 25.2042 136.415 23.2464C134.257 21.2887 129.963 22.0393 129.153 22.0393C127.662 22.0393 126.176 20.0976 123.9 20.0976C121.625 20.0976 119.973 23.8633 118.161 23.8633C116.368 23.8633 114.798 23.1821 112.192 23.1821C107.971 23.1821 107.684 27.5408 105.301 27.5408C102.918 27.5408 102.965 22.5581 100.677 22.5581C97.9591 22.5581 97.9614 27.2943 95.2194 27.2943C92.4155 27.2943 91.0856 23.5911 88.6455 23.5911C86.2054 23.5911 85.6339 26.6184 83.3169 26.5983C81 26.5782 80.1629 25.7919 77.8874 25.7919C75.6118 25.7919 73.0338 27.7604 70.5511 27.7604Z"
          fill="url(#min-fill-grad)"
        />
      </g>
    </svg>
  );
};
